import React, { useState, useEffect, useCallback, forwardRef, useImperativeHandle } from 'react';
import { Input } from '../components';

function slugify(name) {
    const slug = (name || '')
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9\s-]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-')
        .replace(/^-|-$/g, '')
        .slice(0, 80);
    return slug || 'company';
}

const CreateSlugModal = forwardRef(function CreateSlugModal({ companyName, onSubmit, loading, error, onValidityChange }, ref) {
    const [slug, setSlug] = useState(() => slugify(companyName));

    const handleSlugChange = (e) => {
        const raw = e.target.value
            .toLowerCase()
            .replace(/[^a-z0-9-]/g, '')
            .replace(/-+/g, '-')
            .replace(/^-/, '')
            .slice(0, 80);
        setSlug(raw);
    };

    const isValid = slug.length > 0 && /^[a-z0-9]([a-z0-9-]*[a-z0-9])?$/.test(slug);

    useEffect(() => {
        if (onValidityChange) onValidityChange(isValid);
    }, [isValid, onValidityChange]);

    const handleSubmit = useCallback(() => {
        if (isValid) onSubmit(slug);
    }, [isValid, slug, onSubmit]);

    useImperativeHandle(ref, () => ({
        submit: handleSubmit
    }), [handleSubmit]);

    const previewUrl = `${window.location.origin}/buyer-signup/${slug || '...'}`;

    return (
        <div className="create-slug-modal-container">
            <div className="create-slug-section">
                <span className="body-regular colour-secondary">
                    Create a custom URL for your buyer signup page. Buyers can use this link to sign up for your deals list.
                </span>
            </div>
            <div className="create-slug-section">
                <Input
                    label="URL Slug"
                    labelType="regular"
                    value={slug}
                    onChange={handleSlugChange}
                    placeholder="your-company-name"
                    type="text"
                    leftUnit={null}
                    rightUnit={null}
                    unitSwitch={false}
                    leftUnitSelected={true}
                    unitSwitchFunc={null}
                    disabled={loading}
                    multiline={false}
                    error={false}
                    onMouseEnter={null}
                    onMouseLeave={null}
                    reset={false}
                    resetFunc={null}
                    resetPosition={null}
                    focusMultiline={false}
                    prompt={false}
                    submitPromptDisabled={false}
                    submitPrompt={null}
                    onHeightChange={null}
                />
                <span className="label-regular colour-secondary">
                    Only lowercase letters, numbers, and hyphens.
                </span>
            </div>
            <div className="create-slug-section">
                <span className="label-bold colour-secondary">Preview</span>
                <div className="create-slug-preview">
                    <span className="body-regular colour-primary">{previewUrl}</span>
                </div>
            </div>
            {error && (
                <span className="body-regular colour-error">{error}</span>
            )}
        </div>
    );
});

export { slugify };
export default CreateSlugModal;
